import { Form, Input } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import { HelpMessage } from 'utils/constants'
import CIMSTextArea from 'components/CIMSTextArea'

const ClosureFormItems: React.FC = () => {
  return (
    <>
      <Form.Item hidden name="action" initialValue="close">
        <Input />
      </Form.Item>
      <CIMSFormItem
        name="closureNotes"
        label="Closure Notes"
        requiredMessage
        help={HelpMessage.Issues.IssueTracker.ClosureNotes}
      >
        <CIMSTextArea maxLength={2000} />
      </CIMSFormItem>
    </>
  )
}

export default ClosureFormItems
